import { Suspense, lazy } from "react";
import { useData } from "vike-react/useData";
import HeroSection from "@/components/landing/HeroSection";
// Eager (not lazy) so their SEO copy + brand names land in the prerendered
// HTML — lazy sections only render client-side after hydration, so their
// text isn't counted by crawlers. Sinergy carries the bulk of the page's
// indexable word count.
import SinergySection from "@/components/landing/SinergySection";
import MultiBrandSection from "@/components/landing/MultiBrandSection";
import type { IndexPageData } from "./+data";

const ProofSection = lazy(() => import("@/components/landing/ProofSection"));
const LeadFormSection = lazy(
  () => import("@/components/landing/LeadFormSection"),
);
const BlogGridSection = lazy(
  () => import("@/components/landing/BlogGridSection"),
);

const SectionFallback = () => (
  <div className="h-64 w-full animate-pulse bg-surface-elevated/40" />
);

export default function Page() {
  const { featuredArticles } = useData<IndexPageData>();

  return (
    <>
      <h2 className="sr-only">
        Panduan dan konsultasi bisnis cafe — playbook operasional untuk cafe yang untung
      </h2>
      <HeroSection />
      <SinergySection />
      {/* Dark "speed bump" between cream sections — eager so its SEO copy +
          brand names prerender (lazy siblings only hydrate client-side). */}
      <MultiBrandSection />
      <Suspense fallback={<SectionFallback />}>
        <ProofSection />
        <LeadFormSection />
        <BlogGridSection articles={featuredArticles} />
      </Suspense>
    </>
  );
}
